import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { convertCurrency, formatNumber } from "../../../utils/helper";

const AmountInHandCard = () => {
  const dashboardData = useSelector((state) => state.dashboard.dashboardData);
  const currencySelected = useSelector(
    (state) => state.currency.currencySelected
  );
  const exchangeRates = useSelector((state) => state.currency.exchangeRates);
  const amount =
    convertCurrency(
      dashboardData?.remainBudget,
      exchangeRates,
      currencySelected
    ) || 0;
  const surplusOrDeficit = amount >= 0 ? "Surplus" : "Deficit";
  const { t } = useTranslation();
  return (
    <>
      <div
        className={`row mx-0 expenses-card amount-card common-statics-card ${
          surplusOrDeficit === "Deficit" ? "deficit-card" : ""
        }`}
      >
        <div className="statics-details-with-icon">
          <div className="statics-amount-details">
            <span>{t(`dashboard.${surplusOrDeficit.toLowerCase()}`)}</span>
          </div>
        </div>
        <div className="statics-price-div">
          <h5 className="mb-0">
            <small>{currencySelected}</small> {formatNumber(Math.abs(amount))}
          </h5>
        </div>
      </div>
    </>
  );
};

export default AmountInHandCard;
